//Class qui contient les fontions par défaut des scènes.
import { tags } from '../consts/Tags.js';
import TraductionManager from '../prefabs/TraductionManager.js';

export default class AbstractScene extends Phaser.Scene {
    //Initialisation par défaut, à ajouter dans tous les initialisation
    //Data contient les info des transitions (cf onCompleteHandlerTransitionOUT)
    _init(data) {
        // console.log('Start :', this.scene.key, data);
        this.data = {};
        this.traductionManager = new TraductionManager();
        this.game.data.sceneRunning = this.scene.key;

        if (data) {
            // Data à faire passer au besoin
        }
    }

    //Preload de la scene par défaut, initialise les variables utiles
    _preload() {
        this.width = this.cameras.main.width; //Largeur de l'écran
        this.height = this.cameras.main.height; //Hauter de l'écran

        this.dim = this.height * 0.05; //Variable pour adapter les images à la hauteur
        this.ratio = Math.min(this.width / 1920, this.height / 1080); //Ratio de l'écran
    }

    nextScene() {
        var sceneInfo = this.game.data[this.game.data.sceneRunning];
        this.scene.start(sceneInfo.next, this.data);
    }

    clone(element) {
        var clone = Phaser.Utils.Objects.Clone(element);
        this.add.existing(clone);
        return clone;
    }

    createTextElement(x, y, element) {
        let txt = this.add
            .rexTagText(x, y, element.text, {
                fontSize: element.config.size,
                fontFamily: element.config.fontFamily,
                align: this.game.data.langue === 'ara' ? 'right' : element.config.align,
                color: element.config.color,
                backgroundColor: element.config.backColor,
                wrap: {
                    mode: 'character', // 0|'none'|1|'word'|2|'char'|'character'
                    width: element.config.width,
                },
                // wordWrap: { width: element.config.width, useAdvancedWrap: true },
                resolution: 2,
                rtl: this.game.data.langue === 'ara',
                tags: tags,
                padding: { bottom: 10, top: 10 },
            })
            .setOrigin(
                this.game.data.langue === 'ara' ? 1 : element.config.origin.x,
                element.config.origin.y,
            );
        return txt;
    }

    // fonction destroy pour array ou éléments isolés
    destroyElements(elements, isArray = false) {
        isArray ? elements.forEach((el) => el.destroy()) : elements.destroy();
    }
}
